/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { getMe } from '../fn/me/get-me';
import { GetMe$Params } from '../fn/me/get-me';
import { getSiteContexts } from '../fn/me/get-site-contexts';
import { GetSiteContexts$Params } from '../fn/me/get-site-contexts';
import { impersonate } from '../fn/me/impersonate';
import { Impersonate$Params } from '../fn/me/impersonate';
import { Me } from '../models/me';
import { removeImpersonation } from '../fn/me/remove-impersonation';
import { RemoveImpersonation$Params } from '../fn/me/remove-impersonation';
import { SiteContextListResponse } from '../models/site-context-list-response';
import { updateSiteContext } from '../fn/me/update-site-context';
import { UpdateSiteContext$Params } from '../fn/me/update-site-context';


/**
 * Current-user context endpoints. All endpoints require a valid bearer token.
 */
@Injectable({ providedIn: 'root' })
export class MeService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `updateSiteContext()` */
  static readonly UpdateSiteContextPath = '/me/site-context';

  /**
   * Updates current user's active site context.
   *
   * Sets the active site context (siteId + merchantType) for the authenticated user. Required before operations that depend on site context. Requires authentication.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `updateSiteContext()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSiteContext$Response(params: UpdateSiteContext$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = updateSiteContext(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Updates current user's active site context.
   *
   * Sets the active site context (siteId + merchantType) for the authenticated user. Required before operations that depend on site context. Requires authentication.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `updateSiteContext$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  updateSiteContext(params: UpdateSiteContext$Params, context?: HttpContext): Observable<void> {
    const resp = this.updateSiteContext$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `impersonate()` */
  static readonly ImpersonatePath = '/me/impersonation-context';

  /**
   * Sets impersonation context.
   *
   * Allows an admin or impersonation-capable user to impersonate another merchant. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `impersonate()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate$Response(params: Impersonate$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = impersonate(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Sets impersonation context.
   *
   * Allows an admin or impersonation-capable user to impersonate another merchant. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `impersonate$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  impersonate(params: Impersonate$Params, context?: HttpContext): Observable<void> {
    const resp = this.impersonate$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `removeImpersonation()` */
  static readonly RemoveImpersonationPath = '/me/impersonation-context';

  /**
   * Removes impersonation context.
   *
   * Clears the active impersonation context, returning to the caller's own merchant identity. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `removeImpersonation()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeImpersonation$Response(params?: RemoveImpersonation$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
    const obs = removeImpersonation(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Removes impersonation context.
   *
   * Clears the active impersonation context, returning to the caller's own merchant identity. Requires EASYLOT_ADMIN or IMPERSONATION role.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `removeImpersonation$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  removeImpersonation(params?: RemoveImpersonation$Params, context?: HttpContext): Observable<void> {
    const resp = this.removeImpersonation$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<void>): void => r.body)
    );
  }

  /** Path part for operation `getMe()` */
  static readonly GetMePath = '/me';

  /**
   * Gets some user data based on JWT.
   *
   * Returns some user related data based on Json-Web-Token
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getMe()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe$Response(params?: GetMe$Params, context?: HttpContext): Observable<StrictHttpResponse<Me>> {
    const obs = getMe(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets some user data based on JWT.
   *
   * Returns some user related data based on Json-Web-Token
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getMe$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getMe(params?: GetMe$Params, context?: HttpContext): Observable<Me> {
    const resp = this.getMe$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Me>): Me => r.body)
    );
  }

  /** Path part for operation `getSiteContexts()` */
  static readonly GetSiteContextsPath = '/me/available-site-contexts';

  /**
   * Gets current merchant's choosable site contexts.
   *
   * Finds and returns every possible combination of sites and non rejected merchant types.
   *
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `getSiteContexts()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteContexts$Response(params?: GetSiteContexts$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<SiteContextListResponse>>> {
    const obs = getSiteContexts(this.http, this.rootUrl, params, context);
    return obs;
  }

  /**
   * Gets current merchant's choosable site contexts.
   *
   * Finds and returns every possible combination of sites and non rejected merchant types.
   *
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `getSiteContexts$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  getSiteContexts(params?: GetSiteContexts$Params, context?: HttpContext): Observable<Array<SiteContextListResponse>> {
    const resp = this.getSiteContexts$Response(params, context);
    return resp.pipe(
      map((r: StrictHttpResponse<Array<SiteContextListResponse>>): Array<SiteContextListResponse> => r.body)
    );
  }

}
